import {KpiCalculationError} from '@hconnect/common/types'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import {Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText} from '@mui/material'
import {FC, Fragment} from 'react'

import {HierarchyTableNode} from '../types'
import {isKilnOrMillLevel} from '../utils'

type ExpertSystemUsageListContainerProps = {
  currentLocations: HierarchyTableNode[]
  enterLocation: (node: HierarchyTableNode) => void
}

const MIN_LI_HEIGHT_IN_PX = 48

const getAverageLabel = (node: HierarchyTableNode) => {
  if (node.average !== undefined && node.average !== null) {
    return `${Math.round(node.average)}%`
  }

  if (node.averageError === KpiCalculationError.NoKpiValue) {
    return '-'
  }

  if (node.averageError !== undefined && node.average === null) {
    return node.averageError
  }

  return '-'
}

export const ExpertSystemUsageListContainer: FC<ExpertSystemUsageListContainerProps> = ({
  currentLocations,
  enterLocation
}) => {
  return (
    <List dense data-test-id="expert-system-usage-list">
      {currentLocations.map((node, index) => (
        <Fragment key={node.id}>
          {isKilnOrMillLevel(node.type) ? (
            <ListItem
              sx={{minHeight: MIN_LI_HEIGHT_IN_PX}}
              data-test-id={`expert-system-usage-list-item-${node.type}-${node.id}`}
            >
              <ListItemText primary={node.name} />
              <ListItemText
                primary={getAverageLabel(node)}
                sx={{textAlign: 'right', paddingRight: 1}}
              />
            </ListItem>
          ) : (
            <ListItemButton
              onClick={() => enterLocation(node)}
              sx={{minHeight: MIN_LI_HEIGHT_IN_PX}}
              data-test-id={`expert-system-usage-list-item-${node.type}-${node.id}`}
            >
              <ListItemText primary={node.name} />
              <ListItemText
                primary={getAverageLabel(node)}
                sx={{textAlign: 'right', paddingRight: 1}}
              />

              <ListItemIcon sx={{minWidth: 'fit-content'}}>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
          )}
          {index !== currentLocations.length - 1 && <Divider />}
        </Fragment>
      ))}
    </List>
  )
}
